import React from 'react';
import PropTypes from 'prop-types';
import './row.scss';

function Row({ children, wrap, extra }) {
  const valuesRetrieved = {
    wrap: wrap ? ' wrap' : '',
    extra: extra ? ` ${extra}` : '',
  };

  return <div className={`row${valuesRetrieved.wrap}${valuesRetrieved.extra}`}>{children}</div>;
}

Row.propTypes = {
  children: PropTypes.any,
  wrap: PropTypes.bool,
  extra: PropTypes.string,
};

export default Row;
